import { Link } from "@stenajs-webui/elements";
import type { Ref } from "react";
import { useSelector } from "react-redux";

import {
  type TrackerCategory,
  trackEvent,
} from "../../common/tracking/trackerService";
import { resolveCustomsDocumentationEnsURL } from "../../common/utils/customsEnsUtils";
import { getUserNameWithPrefix } from "../../services/authentication/authReducer";
import { getCookieConsent } from "../../services/cookie-consent/slice";

interface EnsLinkProps {
  confirmed: boolean;
  disabled?: boolean;
  ensUrl: string;
  onClick?: () => void;
  optional?: boolean;
  ref?: Ref<HTMLAnchorElement>;
  trackerCategory: TrackerCategory;
}

export const EnsLink = ({
  ensUrl,
  disabled,
  confirmed,
  optional,
  trackerCategory,
  onClick,
  ref,
}: EnsLinkProps) => {
  const userId = useSelector(getUserNameWithPrefix);
  const consent = useSelector(getCookieConsent);

  const onClickLink = () => {
    trackEvent({
      category: trackerCategory,
      action: `Pressed ${optional ? "optional" : ""} ENS link`,
    });
  };

  const href = resolveCustomsDocumentationEnsURL(ensUrl, userId, consent);
  const label = confirmed
    ? "ENS Confirmed"
    : optional
      ? "Optional ENS"
      : "Declare ENS";

  return (
    <Link
      className={"t_ens_link"}
      style={{ whiteSpace: "nowrap" }}
      disabled={disabled}
      href={!onClick ? href : undefined}
      target={"_blank"}
      onClick={onClick ?? onClickLink}
    >
      <span ref={ref}>{label}</span>
    </Link>
  );
};
